import { SHStack } from "@components/design-systems";
import SHSkeleton from "@components/design-systems/sh-skeleton";

export const ModelScreenerToolbarSkeleton = () => {
  return (
    <>
      <SHSkeleton
        sx={{
          borderRadius: "25px",
        }}
        delay={false}
        variant="rounded"
        width="309px"
        height={40}
      />
      <SHStack direction={"row"} spacing={3}>
        <SHSkeleton
          sx={{
            borderRadius: "25px",
          }}
          delay={false}
          variant="rounded"
          width="300px"
          height={40}
        />
        <SHSkeleton
          sx={{
            borderRadius: "25px",
          }}
          delay={false}
          variant="rounded"
          width="100px"
          height={40}
        />
        <SHSkeleton
          sx={{
            borderRadius: "25px",
          }}
          delay={false}
          variant="rounded"
          width="100px"
          height={40}
        />
      </SHStack>
    </>
  );
};
